export default __webpack_public_path__ + "static/media/f_image.2d2b9156.svg";